<template>
	<div v-if="isVisible" class="alert" :class='type'>
		<span class="alert-text">{{ text }}</span>
		<span class="close" @click="hideAlert">&times;</span>
	</div>
</template>

<script>
export default {
	name:  'Message',
	props: {
		text:    String,
		type: {
			type:    String,
			default: 'success'
		},
		visible: {
			type:    Boolean,
			default: false
		}
	},
	data() {
		return {
			isVisible: this.visible
		};
	},
	watch: {
		visible(newVal) {
			this.isVisible = newVal;
			if (newVal) {
				setTimeout(this.hideAlert, 5000);
			}
		}
	},
	methods: {
		hideAlert() {
			this.isVisible = false;
			this.$emit('update:visible', false);
		}
	},
	mounted() {
		if (this.visible) {
			setTimeout(this.hideAlert, 5000);
		}
	}
};
</script>
